import { MARKETING_CHANNEL_ID } from '../../../theme/theme.constants';

const EDITABLE_MARKET_CHANNELS = [
  MARKETING_CHANNEL_ID.figo,
  MARKETING_CHANNEL_ID.ppu,
  MARKETING_CHANNEL_ID.ppuPetCare,
  MARKETING_CHANNEL_ID.spotCan,
];

const MONERIS_MARKET_CHANNELS = [
  MARKETING_CHANNEL_ID.ppu,
];

const PAYMENTECH_MARKET_CHANNELS = [
  MARKETING_CHANNEL_ID.spotCan,
  MARKETING_CHANNEL_ID.ppuPetCare,
];

// max time to wait for the first message from a payment provider iframe.
// if there is no message response within this time window, we consider it
// as not successfuly loaded
const IFRAME_LOAD_TIMEOUT_MS = 15000;

const IFRAME_LOAD_ERROR = 'IFRAME_LOAD_TIMEOUT';

const PAYMENT_PROVIDERS_ID = {
  MONERIS: 5,
  PAYMENTECH: 4,
  SCOTIA_CONNECT: 6,
  STRIPE: 3,
};

const PAYMENT_PROVIDER_NAMES = {
  MONERIS: 'Moneris',
  PAYMENTECH: 'Paymentech',
};

const PAYMENT_TYPES = {
  CREDIT_CARD: 'Credit Card',
};

/**
 * Post message event names.
 */
const MONERIS_HANDLERS = {
  cancelTransaction: 'cancel_transaction',
  pageLoaded: 'page_loaded',
  paymentComplete: 'payment_complete',
  paymentReceipt: 'payment_receipt',
  paymentSubmitted: 'payment_submitted',
  validationEvent: 'validation_event',
};

const MONERIS_RESPONSE_STATUSES = {
  ok: '001',
};

export {
  EDITABLE_MARKET_CHANNELS,
  IFRAME_LOAD_ERROR,
  IFRAME_LOAD_TIMEOUT_MS,
  MONERIS_HANDLERS,
  MONERIS_MARKET_CHANNELS,
  MONERIS_RESPONSE_STATUSES,
  PAYMENT_PROVIDER_NAMES,
  PAYMENT_PROVIDERS_ID,
  PAYMENT_TYPES,
  PAYMENTECH_MARKET_CHANNELS,
};
